import { useEffect, useState } from 'react'
import moment from 'moment'
import { isFunction } from 'lodash'

const localStorage = window.localStorage

/** @deprecated 2025-04-29 */
const useLocalStorageOld = (storageKey, fallbackState, getDate = false) => {
  const [value, setValue] = useState(storageKey && localStorage.getItem(storageKey) ? JSON.parse(localStorage.getItem(storageKey)) : fallbackState)

  useEffect(() => {
    if (storageKey) {
      localStorage.setItem(storageKey, JSON.stringify(value))
    }
  }, [value, storageKey])

  return !getDate ? [value, setValue] : [moment(value), setValue]
}

export default useLocalStorageOld

export const useLocalStorage = (storageKey, fallbackState, factory = null) => {
  const [value, setValue] = useState(storageKey && localStorage.getItem(storageKey) ? JSON.parse(localStorage.getItem(storageKey)) : fallbackState)

  useEffect(() => {
    if (isFunction(factory)) {
      setValue(factory(value))
    }
  }, [])

  useEffect(() => {
    if (storageKey) {
      localStorage.setItem(storageKey, JSON.stringify(value))
    }
  }, [value, storageKey])

  return [value, setValue]
}
